import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";

import {
  EditOutlined,
  CalendarOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import Highlighter from "react-highlight-words";
import Create_icon from "../../../assets/images/create_icon.png";
import Edit_icon from "../../../assets/images/icons/edit_icon.svg";
import Delete_iconbl from "../../../assets/images/icons/delete_iconbl.svg";

import userIcon from "../../../assets/images/daimond-bg.png";
import { useTranslation } from "react-i18next";
import PendantBuilderService from "../../../services/apps-pendantBuilder.service";
import { useSelector } from "react-redux";
import { Button, Checkbox, Col, DatePicker, Input, Modal, Row, Select, Space, Spin, Switch, Table, Tooltip } from "antd";


const { Option } = Select;

export const PendantBuilderManageVendors = (props) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const loginDetials = useSelector((state) => state.loginReducer);
  const [dealerID, setDealerId] = useState("");
  const [manageVendorList, setManageVendorList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleBindDataPendantBuilderVendor(
            loginDetials.loginDetials.responseData.dealerId,
            "",
            "",
            "",
            "",
            "",
            "",
            ""
          );
        }
      }
    }
  }, []);

  const handleBindDataPendantBuilderVendor = (id) => {
    try {
      let inputData = {
        dealerID: id,
        filerType: "",
        currentPage: "",
        recordOnPage: "",
        sortBy: "",
        tagFilter: "",
        searchKeyChar: "",
        searchType: "",
      };
      setLoading(true);
      PendantBuilderService.BindDataPendantBuilderVendor(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setManageVendorList(responseData);
            setLoading(false);
          } else {
            setManageVendorList([]);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: <Tooltip title={t("Vendor")}>{t("Vendor")}</Tooltip>,
      ellipsis: true,
      dataIndex: "vendor",
    },
    {
      title: <Tooltip title={t("Status")}>{t("Status")}</Tooltip>,
      ellipsis: true,
      dataIndex: "status",
    },
    {
      title: <Tooltip title={t("Data Rating")}>{t("Data Rating")}</Tooltip>,
      ellipsis: true,
      dataIndex: "dataRating",
    },
    {
      title: <Tooltip title={t("Items")}>{t("Items")}</Tooltip>,
      ellipsis: true,
      dataIndex: "items",
    },
    {
      title: <Tooltip title={t("Updated")}>{t("Updated")}</Tooltip>,
      ellipsis: true,
      dataIndex: "updated",
    },
    {
      title: <Tooltip title={t("Action")}>{t("Action")}</Tooltip>,
      ellipsis: true,
      dataIndex: "action",
    },
  ];

  const data = [
    {
      key: "1",
      vendor: "Overnight Mountings Ring Builder",
      status: "Connected",
      dataRating: (
        <div className="star-ratings">
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star-half-o" aria-hidden="true"></i>
        </div>
      ),
      items: "38101",
      updated: "05/05/2019",
      action: "Connected",
    },
    {
      key: "1",
      vendor: "Overnight Mountings Ring Builder",
      status: "Connected",
      dataRating: (
        <div className="star-ratings">
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star" aria-hidden="true"></i>
          <i class="fa fa-star-half-o" aria-hidden="true"></i>
        </div>
      ),
      items: "38101",
      updated: "05/05/2019",
      action: "Request Access",
    },
  ];

  return (
    <div className="form__fields">
      <div className="row magento__mapping">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 class="workarea__heading mt-0 mb-0"> {t("Manage Vendors")} </h4>
          </div>
        </div>
        <div className="divForm vendors-section">
          <Spin spinning={loading}>
            <Table columns={columns} dataSource={manageVendorList} />
          </Spin>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendantBuilderManageVendors);
